/* Enhance the native Whatmore block without replacing its player or events. */
if (!customElements.get('windlust-product-motion')) {
  customElements.define('windlust-product-motion', class extends HTMLElement {
    connectedCallback() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseThumbnail = (event) => {
        if (this.motionPreference.matches && event.target.matches?.('video.wht-neo-video')) event.target.pause();
      };
      this.enhance = () => {
        this.querySelectorAll('.wht-neo-rail').forEach((rail) => {
          rail.setAttribute('role', 'group');
          rail.setAttribute('aria-label', this.dataset.groupLabel);
        });
        this.querySelectorAll('.wht-neo-slide').forEach((slide, index) => {
          slide.setAttribute('role', 'button');
          slide.setAttribute('aria-label', `${this.dataset.playLabel}${index ? ` (${index + 1})` : ''}`);
        });
        this.querySelectorAll('.wht-neo-playpause').forEach((button) => button.setAttribute('aria-label', this.dataset.pauseLabel));
        this.querySelectorAll('.wht-neo-widget').forEach((widget) => {
          if (!widget.querySelector('.wht-neo-slide') || widget.querySelector('.wl-motion-open')) return;
          const opener = document.createElement('button');
          opener.type = 'button';
          opener.className = 'wl-motion-open';
          opener.setAttribute('aria-label', this.dataset.playLabel);
          opener.setAttribute('aria-haspopup', 'dialog');
          opener.addEventListener('click', () => {
            const slide = widget.querySelector('.wht-neo-slide.wht-neo-active') || widget.querySelector('.wht-neo-slide');
            slide?.click();
          });
          widget.append(opener);
        });
        const heading = this.querySelector('.wht-neo-heading-inner');
        if (heading && !heading.querySelector('.wl-motion-caption')) {
          const caption = document.createElement('p');
          caption.className = 'wl-motion-caption';
          caption.textContent = this.dataset.caption;
          const invitation = document.createElement('span');
          invitation.className = 'wl-motion-invitation';
          invitation.textContent = this.dataset.invitation;
          heading.append(caption, invitation);
        }
        if (this.motionPreference.matches) this.querySelectorAll('video.wht-neo-video').forEach((video) => video.pause());
      };
      this.addEventListener('play', this.pauseThumbnail, true);
      this.motionPreference.addEventListener('change', this.enhance);
      this.observer = new MutationObserver(this.enhance);
      this.observer.observe(this, { childList: true, subtree: true });
      this.enhance();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('play', this.pauseThumbnail, true);
      this.motionPreference?.removeEventListener('change', this.enhance);
    }
  });
}
